import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { RegistroIngSalCodPublComponent } from './registro-ing-sal-cod-publ.component';


const routes: Routes = [
    {
        path: '', component: RegistroIngSalCodPublComponent,

    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class RegistroIngSalCodPublRoutingModule { }
